export default __webpack_public_path__ + "static/media/educacion.d54d8966.jpg";